import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import IconButton from "../../common/base/IconButton.vue.mjs";
import useControl from "./useMoreControlHooks.mjs";
import ChatControl from "../ChatControl.vue.mjs";
import InviteControl from "../InviteControl.vue.mjs";
import ContactControl from "../ContactControl.vue.mjs";
import { useRoomStore } from "../../../stores/room.mjs";
import ExtensionIcon from "../../common/icons/ExtensionIcon.vue.mjs";
import bus from "../../../hooks/useMitt.mjs";
import "../../../directives/vTap.mjs";
import "../../../services/main.mjs";
import { roomService } from "../../../services/roomService.mjs";
import "../../../locales/index.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../../utils/environment.mjs";
import "mitt";
import "../../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MoreControlH5",
  emits: ["show-overlay"],
  setup(__props, { emit }) {
    const moreControlConfig = roomService.getComponentConfig("MoreControl");
    const showMoreContent = ref(false);
    const moreContentRef = ref();
    const { t, sidebarName } = useControl();
    const roomStore = useRoomStore();
    function showMore() {
      showMoreContent.value = true;
    }
    function handleCancelControl() {
      showMoreContent.value = false;
    }
    function handleControlClick(name) {
      bus.emit("experience-communication", name);
    }
    function handleShowOverlay(data) {
      showMoreContent.value = false;
      emit("show-overlay", data);
    }
    function handleDocumentClick(event) {
      if (showMoreContent.value && !moreContentRef.value.contains(event.target)) {
        showMoreContent.value = false;
      }
    }
    onMounted(() => {
      document == null ? void 0 : document.addEventListener("click", handleDocumentClick, true);
    });
    onUnmounted(() => {
      document == null ? void 0 : document.removeEventListener("click", handleDocumentClick, true);
    });
    return { __sfc: true, moreControlConfig, showMoreContent, moreContentRef, t, sidebarName, roomStore, emit, showMore, handleCancelControl, handleControlClick, handleShowOverlay, handleDocumentClick, IconButton, ChatControl, InviteControl, ContactControl, ExtensionIcon };
  }
});
export {
  _sfc_main as default
};
